import { Injectable } from '@angular/core';
import {
  HttpErrorResponse,
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor
} from '@angular/common/http';
import { firstValueFrom, Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { ErrorModalService } from '@app/shared/modals/error-modal/error-modal.service';
import { TranslateService } from '@ngx-translate/core';

@Injectable()
export class ErrorHttpInterceptor implements HttpInterceptor {
  translations: any;
  undefinedClientError: any;
  noInternetConnection: any;
  undefinedErrorDescription: any;
  undefinedStatusCode: any;
  undefinedServerError: any;
  undefinedError: any;

  constructor(private errorModalService: ErrorModalService,
    private translateService: TranslateService) { }

  async getTranslations() {
    const translations = await firstValueFrom(this.translateService.get([
      'Error.NoInternetConnection',
      'Error.UndefinedClientError',
      'Error.UndefinedErrorDescription',
      'Error.UndefinedStatusCode',
      'Error.UndefinedServerError',
      'Error.UndefinedError'
    ]));

    this.translations = translations;
    this.noInternetConnection = this.translations['Error.NoInternetConnection'];
    this.undefinedClientError = this.translations['Error.UndefinedClientError'];
    this.undefinedErrorDescription = this.translations['Error.UndefinedErrorDescription'];
    this.undefinedStatusCode = this.translations['Error.UndefinedStatusCode'];
    this.undefinedServerError = this.translations['Error.UndefinedServerError'];
    this.undefinedError = this.translations['Error.UndefinedError'];
  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    this.getTranslations();

       return next.handle(request)
      .pipe(
        catchError((error: HttpErrorResponse | any): Observable<any> => {
          let httpError = null;
          /* istanbul ignore else */
          if (!navigator.onLine) {
            httpError = { message: this.noInternetConnection };
          } else {
            try {
              /* istanbul ignore else */
              if (error.error instanceof ErrorEvent) {
                httpError = {
                  message: error.error.message || this.undefinedClientError,
                  description: error.error.description || error.error.message || this.undefinedErrorDescription
                };
              } else {
                httpError = {
                  statusCode: error.status || this.undefinedStatusCode,
                  message: error.message || this.undefinedServerError,
                  description: error.error.description || error.error.message || this.undefinedErrorDescription
                };
              }
            } catch {
              httpError = {
                message: error.error.message || this.undefinedClientError,
                description: error.error.description || error.error.message || this.undefinedErrorDescription
              };
            }
          }

          // do not display errors related to the error service
          /* istanbul ignore else */
          if (!error.message.includes('/api/error') && !error.message.includes('/api/cast/search')
            && !error.message.includes('/api/character/search')) {
            console.log('error.message.....', error.message);
            this.errorModalService.showErrorModal(httpError);
          }

          return throwError(error);
        })
      );
  }
}
